import React, { forwardRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "../../styles/components/ActionDropDown.scss";
import { Dropdown as Dropdown2 } from "@els/els-react--dropdown";

const CustomToggle = forwardRef(({ children, onClick }: any, ref: any) => (
  <span
    ref={ref}
    className="customActionToggle"
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));

interface ActionDropDownType {
  row: any;
  actionList: any[];
  onActionClick: (row: any, action: any) => void;
  useLeyden?: boolean;
}

function ActionDropDown({
  row,
  actionList,
  onActionClick,
  useLeyden,
}: ActionDropDownType) {
  const leydenOptions = actionList.map(list => {
    return {
      label: list.value,
      value: list.action,
    };
  });
  return (
    <div className="actionContainer">
      {useLeyden ? (
        <Dropdown2
          selected={{ label: "..." }}
          showSelectedAsLabel={true}
          id="action-select"
          options={leydenOptions}
          flyoutProps={{
            placement: "bottom-end",
            pointer: true,
            pointerType: "primary",
          }}
          className="dropDownLeyden"
          onChange={(e: any) => {
            onActionClick(row, e?.value);
          }}
        />
      ) : (
        <Dropdown as={"span"} style={{ marginBottom: "10px" }} align={"end"}>
          <Dropdown.Toggle as={CustomToggle}>...</Dropdown.Toggle>
          <Dropdown.Menu
            className={`dropdownMenu ${
              actionList.length === 1 ? "dropdownMenuNew" : ""
            }`}
          >
            {actionList.map((list: any) => {
              return (
                <Dropdown.Item
                  key={list.value}
                  onClick={() => onActionClick(row, list.action)}
                >
                  {list.value}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  );
}

export default ActionDropDown;
